export const TABS = {
  BASIC: 'basic',
  INFO: 'info',
  DELIVERY: 'delivery',
  REVIEW: 'review',
  INQUIRY: 'inquiry',
} as const;

export const TABS_LABELS = {
  [TABS.BASIC]: '상품 상세',
  [TABS.INFO]: '상품정보',
  [TABS.DELIVERY]: '구매/배송',
  [TABS.REVIEW]: '후기/리뷰',
  [TABS.INQUIRY]: '문의',
} as const;
